import { axios } from '@Root/API'

export const getMainTabsPermissions = () => {
	return axios.get(`get-data-menu-permissions`)
}
